export default {
  state: {
    flag: false,
    msg: '',
  },
  mutations: {
    undoWarn: (state: any) => {
      state.flag = false;
    },
    onWarn: (state: any, msg: any) => {
      state.msg = msg;
      state.flag = true;
    },
  },
};
